import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "./site";
import { DEFAULTS } from "./defaults";

const ContentContext = createContext(DEFAULTS);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULTS);
  useEffect(() => {
    axios
      .get(`${API}/content`)
      .then((res) => setContent({ ...DEFAULTS, ...(res.data || {}) }))
      .catch(() => {});
  }, []);
  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
